const forms = [
  // Laboratory Department
  "analysis", // forms
  "bacteriology",
  "biopsy", // forms
  "chemistry",
  "coagulation",
  "compatibility", // forms
  "hematology",
  "miscellaneous", // special (must check the length)
  "parasitology",
  "pbs",
  "paps", // forms | 10
  "serology",
  "urinalysis",

  // Radiology Department
  "ecg", // 13
  "2DEcho",
  "ultrasound",
  "xray", // 16
  "certicifate",
  "examination", // 16
  "electrolyte",
];

export default forms;
